"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _layout = require("@berlitz/globals/lib/components/layout");
var _typography = require("@berlitz/globals/lib/components/typography");
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _button = _interopRequireDefault(require("@berlitz/button"));
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var darkBackgrounds = ['brandPrimary', 'ui05', 'purple'];
var BlockContentArea = function BlockContentArea(_ref) {
  var alignCenter = _ref.alignCenter,
    backgroundColor = _ref.backgroundColor,
    callToActionHref = _ref.callToActionHref,
    callToActionLinkComponent = _ref.callToActionLinkComponent,
    callToActionText = _ref.callToActionText,
    children = _ref.children,
    disablePaddingBottom = _ref.disablePaddingBottom,
    disablePaddingTop = _ref.disablePaddingTop,
    innerHTML = _ref.innerHTML,
    size = _ref.size,
    fullWidth = _ref.fullWidth;
  var invertText = darkBackgrounds.includes(backgroundColor);
  var ghostButton = invertText || backgroundColor === 'brandSecondary';
  var ghostButtonInvert = backgroundColor === 'brandSecondary';
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    alignCenter: alignCenter,
    backgroundColor: backgroundColor,
    "data-key": "max-block-contentarea",
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: fullWidth ? 'xs' : 'lg'
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, _extends({
    xs: 12
  }, fullWidth ? {
    sm: 12,
    md: 10
  } : {}, {
    lg: fullWidth ? 10 : 9
  }), innerHTML ? /*#__PURE__*/_react.default.createElement(_typography.RichText, {
    inverse: invertText,
    dangerouslySetInnerHTML: {
      __html: innerHTML
    }
  }) : children)), callToActionText && callToActionHref && /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: fullWidth ? 'xs' : 'lg'
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, _extends({
    xs: 12
  }, fullWidth ? {
    sm: 12,
    md: 10
  } : {}, {
    lg: fullWidth ? 10 : 9
  }), /*#__PURE__*/_react.default.createElement(_spacer.default, {
    top: true,
    size: "lg"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    as: callToActionLinkComponent,
    ghost: ghostButton,
    ghostInvert: ghostButtonInvert,
    href: callToActionHref,
    inlineBlock: true
  }, callToActionText))))));
};
BlockContentArea.defaultProps = {
  callToActionLinkComponent: 'a',
  size: 'lg',
  alignCenter: false
};
var _default = BlockContentArea;
exports.default = _default;